import { createAlova } from "alova"
import VueHook from "alova/vue"
import { axiosRequestAdapter } from "@alova/adapter-axios"
import { useRouter } from "vue-router"
const router = useRouter()

// 创建 alova 实例
const alovaInstance = createAlova({
  // 使用 Vue 的 Hook 能力
  statesHook: VueHook,
  // 请求适配器使用 axios（需安装 axios）
  requestAdapter: axiosRequestAdapter({
    withCredentials: true,
  }),
  // 全局请求配置（可设置 baseURL、超时时间等）
  // baseURL: "http://192.168.2.26:5005/api",
  baseURL: "https://aieduapi.teachmusic.cn/api",
  timeout: 10000,
  // 请求拦截器：添加 Token 到请求头
  beforeRequest: (method) => {
    // 根据URL路径决定使用哪个token
    const currentPath = window.location.pathname
    let tokenKey = "jwt_token"

    if (currentPath.includes("/teacher/")) {
      tokenKey = "jwt_teacher_token"
    } else if (currentPath.includes("/student/")) {
      tokenKey = "jwt_student_token"
    }

    const token = localStorage.getItem(tokenKey)
    if (token) {
      // 通过 method.config 配置请求头（axios 适配器下对应 axios 的 config）
      method.config.headers.Authorization = `Bearer ${token}`
    }
  },
  // 响应拦截器：处理 Token 过期等异常
  responded: {
    // 响应成功的回调（状态码 2xx）
    onSuccess: async (response, method) => {
      // console.log("response:" + JSON.stringify(response))
      // 直接返回响应体（根据后端返回结构调整，假设返回 { code: 200, data: ... }）
      if (response.status >= 200 && response.status < 300) {
        const res = await response
        if (res.data.code !== 1000) {
          // throw new Error(res.message || '请求失败');
          alert(res.data.message)
        }
        return res.data
      }
      throw new Error(`HTTP 错误：${response.status}`)
    },
    // 响应失败的回调（非 2xx 状态码）
    onError: (error, method) => {
      // 处理 401 状态码（Token 过期或无效）
      // console.log("error:" + JSON.stringify(error))
      if (error.response?.status === 401) {
        // 根据URL路径决定清除哪个token
        const currentPath = window.location.pathname
        let tokenKey = "jwt_token"
        if (currentPath.includes("/teacher/")) {
          tokenKey = "jwt_teacher_token"
        } else if (currentPath.includes("/student/")) {
          tokenKey = "jwt_student_token"
        }
        // localStorage.removeItem(tokenKey); // 清除本地 Token
        // 跳转到对应的登录页
        router.push({ path: "home" })
      }
      return Promise.reject(error)
    },
  },
})

export default alovaInstance
